import HttpManager from "../../../../services/HttpManager";
import { FloatingListDTO, FloatingQuery, FloatingRow, FloatingView } from "../../../../models/EnrollmentUpdateDTO";

/*
	Fuente de datos de la pestaña Flotantes: `GET enrollmentUpdates/_floating` (filtros, conteos y paginación los hace el servidor,
	de la más reciente a la más vieja) y `POST enrollmentUpdates/_floatingContacted` al abrir el WhatsApp de una flotante.
*/

export const POR_PAGINA = 50;

/** Filtros de la pantalla, ya en el formato que entiende el servidor. */
export interface FiltrosFlotantes {
	motivos: string[];
	planteles: string[];
	curso: string[];
	origen: { id: number; nombre: string } | null;
	desde: string;
	hasta: string;
	dias: string[];
	pago: string[];
	contacto: string[];
}

export const SIN_FILTROS: FiltrosFlotantes = { motivos: [], planteles: [], curso: [], origen: null, desde: "", hasta: "", dias: [], pago: [], contacto: [] };

export const hayFiltros = (f: FiltrosFlotantes): boolean =>
	f.motivos.length + f.planteles.length + f.curso.length + f.dias.length + f.pago.length + f.contacto.length > 0 || !!f.origen || !!f.desde || !!f.hasta;

/** Los filtros de días, pago y contacto solo existen en Flotantes: en Por Cerrar el servidor no los aplica y no se mandan. */
export const consulta = (view: FloatingView, f: FiltrosFlotantes, page: number, perPage: number = POR_PAGINA): FloatingQuery => ({
	view, page, perPage,
	campusIds: f.planteles.join(","),
	reasons: f.motivos.join(","),
	courseId: Number(f.curso[0]) || null,
	fromScheduleId: f.origen?.id ?? null,
	from: f.desde, to: f.hasta,
	...(view === "flotantes" ? {
		minDays: Number(f.dias[0]) || null,
		owes: f.pago[0] === "debe" || f.pago[0] === "al_corriente" ? f.pago[0] : undefined,
		contacted: f.contacto[0] === "contactada" || f.contacto[0] === "sin_contactar" ? f.contacto[0] : undefined
	} : {})
});

export const cargarFlotantes = (campusId: number, q: FloatingQuery): Promise<FloatingListDTO> =>
	HttpManager.getInstance().enrollmentUpdatesService.floating(campusId, q).then((r) => r.data);

/** Cuántas hay en cada vista (con los planteles elegidos), una petición corta por vista. */
export const contarVistas = (campusId: number, planteles: string[]): Promise<{ flotantes: number; porCerrar: number }> =>
	Promise.all((["flotantes", "por_cerrar"] as FloatingView[]).map((view) => cargarFlotantes(campusId, { view, campusIds: planteles.join(","), page: 1, perPage: 1 })))
		.then(([a, b]) => ({ flotantes: a.total, porCerrar: b.total }));

/** Todas las filas que cumplen los filtros (todas las páginas), para WhatsApp a Varios. */
export const todasLasFilas = async (campusId: number, view: FloatingView, f: FiltrosFlotantes): Promise<FloatingRow[]> => {
	const out: FloatingRow[] = [];
	for (let page = 1; page <= 25; page++) {
		const r = await cargarFlotantes(campusId, consulta(view, f, page, 200));
		out.push(...r.data);
		if (page >= r.lastPage) { break; }
	}
	return out;
};

export const marcarContactada = (campusId: number, enrollmentId: number) =>
	HttpManager.getInstance().enrollmentUpdatesService.floatingContacted(campusId, enrollmentId).then((r) => r.data);
